// eslint-disable-next-line no-restricted-imports
import {observe as originalObserve} from '@github/selector-observer'
import {sendEvent} from '@github-ui/hydro-analytics'
import {isFeatureEnabled} from '@github-ui/feature-flags'

type InitializerCallback = (el: Element) => void | {add?: (el: Element) => void; remove?: (el: Element) => void}

type Options = {
  initialize?: InitializerCallback
  add?: (el: Element) => void
  remove?: (el: Element) => void
  subscribe?: (el: Element) => {unsubscribe(): void}
}

function sendToHydro(selector: string) {
  if (!isFeatureEnabled('selector_observer_stats')) return

  sendEvent(
    'selector-observer.observe',
    {
      selector,
      controller: document.querySelector<HTMLMetaElement>('meta[name="route-controller"]')?.content,
      action: document.querySelector<HTMLMetaElement>('meta[name="route-action"]')?.content,
      routePattern: document.querySelector<HTMLMetaElement>('meta[name="route-pattern"]')?.content,
    },
    {batched: true},
  )
}

function wrapCallback<T extends (...args: never[]) => unknown>(selector: string, fn: T): T {
  return ((...args: Parameters<T>) => {
    sendToHydro(selector)
    return fn(...args)
  }) as unknown as T
}

export function observe(selector: string, initializeOrOptions: InitializerCallback | Options): {abort(): void} {
  if (typeof initializeOrOptions === 'function') {
    return originalObserve(selector, wrapCallback(selector, initializeOrOptions))
  }

  const {initialize, add, remove, subscribe, ...rest} = initializeOrOptions
  return originalObserve(selector, {
    ...rest,
    ...(initialize && {initialize: wrapCallback(selector, initialize)}),
    ...(add && {add: wrapCallback(selector, add)}),
    ...(remove && {remove: wrapCallback(selector, remove)}),
    ...(subscribe && {subscribe: wrapCallback(selector, subscribe)}),
  })
}
